import { apiClient } from '../../services/apiClient.js';
import { CRITICAL_MINERALS, NON_CRITICAL_MINERALS } from '../../config/commodityConfig.js';
import { sortAllFilterOptions, createSortedMineralOptions } from '../../utils/filterSorting.js';

export class FilterDataLoader {
  constructor() {
    this.filterOptions = {};
  }

  async loadFilterOptions() {
    try {
      // Load filter options from API
      const [countries, commodities, mineTypes, statuses] = await Promise.all([
        apiClient.getCountryFilterOptions(),
        apiClient.getCommodityFilterOptions(),
        apiClient.getMineTypeFilterOptions(),
        apiClient.getMineStatusFilterOptions()
      ]);

      // Separate commodities into critical and non-critical
      const allCommodities = commodities.options || [];
      const criticalCommodities = allCommodities.filter(commodity =>
        CRITICAL_MINERALS.includes(commodity.value)
      );
      const nonCriticalCommodities = allCommodities.filter(commodity =>
        NON_CRITICAL_MINERALS.includes(commodity.value)
      );

      // Create the new minerals structure with category options
      const mineralOptions = createSortedMineralOptions(criticalCommodities, nonCriticalCommodities);

      // Prepare all filter options
      const rawFilterOptions = {
        country: countries.options || [],
        minerals: mineralOptions,
        mine_type: mineTypes.options || [],
        mine_status: statuses.options || []
      };

      // Sort all options alphabetically (except minerals which are already sorted with categories first)
      this.filterOptions = {
        country: sortAllFilterOptions({ country: rawFilterOptions.country }).country,
        minerals: rawFilterOptions.minerals, // Already sorted with categories first
        mine_type: sortAllFilterOptions({ mine_type: rawFilterOptions.mine_type }).mine_type,
        mine_status: sortAllFilterOptions({ mine_status: rawFilterOptions.mine_status }).mine_status
      };

      return this.filterOptions;
    } catch (error) {
      console.error('Failed to load filter options:', error);
      throw error;
    }
  }

  getFilterOptions() {
    return this.filterOptions;
  }

  /**
   * Get critical mineral names for filter logic
   */
  getCriticalMinerals() {
    return CRITICAL_MINERALS;
  }

  /**
   * Get non-critical mineral names for filter logic
   */
  getNonCriticalMinerals() {
    return NON_CRITICAL_MINERALS;
  }
}